import { render, staticRenderFns } from "./DSSortIcon.vue?vue&type=template&id=251eebf7&scoped=true&"
import script from "./DSSortIcon.vue?vue&type=script&lang=js&"
export * from "./DSSortIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251eebf7",
  null
  
)

export default component.exports